import { OfferBreadcrumbs } from '@/features/subcontractor-bids/components/offer-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { offerDetailsQuery, procurementFindingsQuery } from '@/features/subcontractor-bids/queries';
import { ReservationsPage } from '@/features/subcontractor-bids/reservations/components/reservations-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/',
)({
  component: RouteComponent,
  loader: (opts) =>
    Promise.all([
      opts.context.queryClient.query({
        ...offerDetailsQuery(opts.params.subcontractorId),
        staleTime: 'static',
      }),
      opts.context.queryClient.query({
        ...procurementFindingsQuery(opts.params.procurementId),
        staleTime: 'static',
      }),
    ]),
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId, subcontractorId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId"
          params={{ projectId, workspaceId, procurementId }}
        />
        <OfferBreadcrumbs subcontractorId={subcontractorId} />
        <HeaderChatButton />
      </Header>
      <ReservationsPage />
    </>
  );
}
